<template>
<div>
  <vb-form-row item-name="下取りコード">
    <template #title>
      <v-tooltip v-model="openHint.buybackCode"
                 :open-on-hover="false"
                 :open-on-click="false"
                 top
                 color="transparent"
                 min-width="360px"
                 max-width="500"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            @click="openHint.buybackCode = !openHint.buybackCode"
            color="grey lighten-1"
          >
            mdi-help-circle
          </v-icon>
        </template>
        <v-card v-if="openHint.buybackCode"
                v-click-outside="openHint.buybackCode? onClickToolTipBuybackOutside : null" flat
                outlined>
          <v-card-title class="pa-3 pb-1 text-subtitle-2">
            下取りコードとは？
          </v-card-title>
          <v-card-text class="pa-3 pt-0">
            バリューブックスから本を購入された際に、納品書に８文字の下取りコードが記載されている場合がございます。<br>
            購入された本を同梱し、下取りコードを入力いただければ、納品書に記載された金額で買い取ります。<br>
            なお、買取の際に入力できる下取りコードはひとつまでとなっております。<br>
            また、本の状態が悪化している場合は減額、もしくは買い取れない場合がありますので、ご注意ください。
          </v-card-text>
        </v-card>
      </v-tooltip>
    </template>
    <template #input>
      <v-sheet class="col-12 pa-0" max-width="320">
        <validation-provider v-slot="{ errors, invalid, validated }"
                             :rules="`alpha_num_org|length:${buybackCodeMaxLength}|buyback_code`"
                             name="下取りコード"
                             :debounce="1000">
          <v-text-field
            :value="formItemsGetter.buybackCode"
            v-model="formItemsGetter.buybackCode"
            @input="mutateBuybackCode"
            :error-messages="errors"
            outlined
            dense
            height="44px"
            hide-details="auto"
            :maxlength="buybackCodeMaxLength"
            :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
          ></v-text-field>
          <p
            v-if="(validated && !invalid && formItemsGetter.buybackCode && formItemsGetter.buybackCode.length === buybackCodeMaxLength)"
            class="pt-2 error--text caption">下取りコードを適用します。</p>
        </validation-provider>
      </v-sheet>
    </template>
  </vb-form-row>
</div>
</template>

<script>
import VbFormRow from "../buy/vb-form-row.vue";
import InputValueConversion from "../../../libs/InputValueConversion.js";
import {localize} from "vee-validate";
export default {
  name: "vb-buyback-code",
  components: {VbFormRow},
  props: {
    formItemsSetter: {
      type: Function,
      required: true
    },
    formItemsGetter: {
      type: Object,
      required: true,
      default: {}
    },
  },
  data() {
    return {
      buybackCodeMaxLength: VueConfig.sell.buybackCodeMaxLength,
      openHint: {
        buybackCode: false,
      }
    }
  },
  methods: {
    mutateBuybackCode(event) {
      this.$nextTick(() => {
        const trimmed = this.fullWidthToHalfWidthAlphanum(event.trim());

        this.formItemsSetter({name: 'buybackCode', value: trimmed});
      });
    },
    fullWidthToHalfWidthAlphanum(value) {
      return InputValueConversion.fullWidthToHalfWidthAlphanum(value);
    },
    onClickToolTipBuybackOutside() {
      this.openHint.buybackCode = false;
    },
  },
  mounted() {
    localize('ja', {
      fields: {
        '下取りコード': {
          length: '下取りコードは' + this.buybackCodeMaxLength + '文字で入力してください。',
        }
      }
    });
  }
}
</script>

<style scoped>

</style>